import { LogOut } from 'lucide-react';
import { useAuth } from '../../lib/auth';
import { Banner, Button } from '../../components/ui';
import { TwoFactorCard } from './TwoFactorCard';

/**
 * Vollbild, solange ein Administrator die vorgeschriebene Zwei-Faktor-Anmeldung (Einstellung
 * „Zwei-Faktor-Anmeldung für Administratoren erzwingen“) noch nicht eingerichtet hat. Der Server sperrt bis dahin
 * alles außer Einrichtung, Abmelden und Passwortwechsel (403 TWO_FACTOR_SETUP_REQUIRED). Nach dem Aktivieren lädt
 * TwoFactorCard /auth/me neu → die Kasse öffnet sich normal.
 */
export default function ForcedTwoFactor() {
  const { me, logout } = useAuth();
  return (
    <div className="auth-page">
      <div className="auth-card stack loose" style={{ width: 'min(560px, 100%)' }}>
        <h1>Zwei-Faktor-Anmeldung einrichten</h1>
        <Banner tone="info">
          Für Administratoren ist die Zwei-Faktor-Anmeldung vorgeschrieben. Bitte richte sie jetzt ein, {me?.user.displayName ?? 'du'} – du brauchst dein Handy mit einer Authenticator-App.
        </Banner>
        <TwoFactorCard required startSignal={0} />
        <Button variant="ghost" icon={<LogOut size={16} />} onClick={() => void logout()}>Abmelden</Button>
      </div>
    </div>
  );
}
